import CantFindAnswer from "../../global/cant-find-answers/CantFindAnswer";
import TermsFirstSection from "./TermsFirstSection";
import "./Terms.css";
export default function TermsOfServices() {
  return (
    <>
      <TermsFirstSection
        title="Terms of Services"
        text="Last Updated 07.11.2024"
      />
      <section id="terms_content_section">
        <div className="container">
          <div className="terms-content-wrapper">
            <p>
              These terms of use (“Terms of Use”) set forth the terms and
              conditions of Coding Ninjas Inc. d/b/a Lemon.io (“us”, “our”, and
              “Lemon.io”) applicable to your (“you”, “your” and “yourself”) use
              of the Lemon.io website located at{" "}
              <a
                href="https://lemon.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://lemon.io
              </a>
              , and any related software, applications, services and/or products
              (collectively the “Platform”), including without limitation your
              use of the Platform: (A) to obtain development services as a
              "Client" (B) to perform development services as a "Developer"
              and/or (C) to partner with us to provide developers to clients as
              a “Partner.” Your use of the Platform constitutes your agreement
              to all of the terms and conditions in the Terms of Use, and
              Lemon.io encourages you to read the Terms of Use carefully. In the
              event of a conflict between these Terms of Use and any other
              agreement, whether written or oral, between Lemon.io and you,
              whether in your individual capacity or as the representative of a
              Client, Developer, or Partner, these Terms of Use shall supersede
              and control.
            </p>
            <p>
              <strong>
                IF YOU OBJECT TO ANYTHING IN THE TERMS OF USE, INCLUDING THE
                JURY WAIVER AND CLASS ACTION WAIVER IN SECTION 25, OR OTHERWISE
                DO NOT UNDERSTAND OR AGREE TO BE BOUND BY THESE TERMS OF USE, DO
                NOT USE THE PLATFORM AND EXIT IMMEDIATELY, AS YOU ARE NOT
                AUTHORIZED TO USE THE PLATFORM.
              </strong>
            </p>
            <ol>
              <li>
                <p>
                  For purposes of the Terms of Use, “Lemon.io” means and
                  includes Lemon.io and its subsidiaries and affiliates, and its
                  and their investors, officers, directors, employees, agents,
                  representatives and assigns. “User” means each person who
                  accesses or uses the Platform, including Clients, Developers
                  and Partners.
                </p>
              </li>
              <li>
                <p>
                  You understand and agree that Lemon.io may revise, modify
                  and/or supplement the Terms of Use (the “Revised Terms of
                  Use”) at any time. Any Revised Terms of Use will be effective
                  immediately after notice is sent to you via email. If you do
                  not agree to the Revised Terms of Use, you must stop using the
                  Platform and close your account. You can deactivate your
                  account by emailing us at{" "}
                  <a href="mailto:support@lemon.io">support@lemon.io</a>. By
                  continuing to use the Platform following notice, or by failing
                  to deactivate your account, you hereby expressly agree to be
                  bound by the Revised Terms of Use and acknowledge that your
                  continued use of the Platform is valid consideration for the
                  Revised Terms of Use.
                </p>
              </li>
              <li>
                <p>
                  Privacy Policy. Refer to the Lemon.io Privacy Policy at
                  https://lemon.io/privacy-policy/ for information on how
                  Lemon.io collects, uses and discloses information about you.
                </p>
              </li>
              <li>
                <p>
                  License. Subject to the terms and conditions set forth in the
                  Terms of Use, Lemon.io grants you a personal, nonexclusive,
                  nontransferable, revocable license to access and use the
                  Platform solely for your personal, noncommercial use. Rights
                  not expressly granted to you in the Terms of Use are reserved
                  by Lemon.io.
                </p>
              </li>
              <li>
                <p>
                  Platform Eligibility. To be eligible to use the Platform, you
                  represent, warrant and covenant that you: (A) Are eighteen
                  (18) years of age or older; (B) Have full power and authority
                  to enter into the Terms of Use and to be bound by the Terms of
                  Use; (C) Will not violate any other agreement to which you are
                  a party by agreeing to the Terms of Use; (D) Are not
                  restricted from using the Platform in any way or for any
                  reason; (E) Are not using the Platform for reasons that are in
                  competition with or adverse to Lemon.io; and (F) Will only
                  maintain one account at any given time.
                </p>
              </li>
              <li>
                <p>
                  o Jury; Class Action Waiver. YOU HEREBY IRREVOCABLY WAIVE YOUR
                  RIGHT TO TRIAL BY JURY IN ANY DISPUTE INVOLVING LEMON.IO. YOU
                  FURTHER AGREE TO WAIVE ANY RIGHT TO RESOLVE ANY DISPUTE
                  INVOLVING LEMON.IO AS A REPRESENTATIVE OR MEMBER IN ANY CLASS
                  OR REPRESENTATIVE ACTION, EXCEPT WHERE SUCH WAIVER IS
                  PROHIBITED BY LAW OR DEEMED BY A COURT OF LAW TO BE AGAINST
                  PUBLIC POLICY. TO THE EXTENT YOU ARE PERMITTED BY LAW OR COURT
                  OF LAW TO PROCEED WITH A CLASS OR REPRESENTATIVE ACTION, YOU
                  AGREE THAT: (I) THE PREVAILING PARTY SHALL NOT BE ENTITLED TO
                  RECOVER ATTORNEYS’ FEES OR COSTS ASSOCIATED WITH PURSUING THE
                  CLASS OR REPRESENTATIVE ACTION; AND (II) YOU WILL NOT SUBMIT A
                  CLAIM OR OTHERWISE PARTICIPATE IN ANY RECOVERY SECURED
                </p>
              </li>
              <li>
                <p>
                  Disclaimer of Warranties. THE PLATFORM IS PROVIDED ON AN "AS
                  IS" AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OF ANY KIND,
                  EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, WARRANTIES
                  OF TITLE, CUSTOM, USAGE, MERCHANTABILITY, NONINFRINGEMENT OR
                  FITNESS FOR A PARTICULAR PURPOSE. YOU HEREBY EXPRESSLY AGREE
                  THAT USE OF THE PLATFORM IS AT YOUR SOLE AND EXCLUSIVE RISK.
                  FURTHER, LEMON.IO DOES NOT REPRESENT OR WARRANT THAT THE
                  PLATFORM IS FREE FROM VIRUSES, TROJAN HORSES, WORMS, TIME
                  BOMBS, SPIDERS, CANCEL BOTS, CORRUPTED FILES, OR ANY OTHER
                  SIMILAR SOFTWARE, MALWARE OR MATERIALS THAT MAY DAMAGE,
                  INTERFERE WITH, DISRUPT, IMPAIR, DISABLE OR OTHERWISE
                  OVERBURDEN THE OPERATION OF ANY DEVICE, COMPUTER SYSTEM OR
                  NETWORK. 
                </p>
              </li>
              <li>
                <p>
                  Disclaimer of Warranties. THE PLATFORM IS PROVIDED ON AN "AS
                  IS" AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OF ANY KIND,
                  EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, WARRANTIES
                  OF TITLE, CUSTOM, USAGE, MERCHANTABILITY, NONINFRINGEMENT OR
                  FITNESS FOR A PARTICULAR PURPOSE. YOU HEREBY EXPRESSLY AGREE
                  THAT USE OF THE PLATFORM IS AT YOUR SOLE AND EXCLUSIVE RISK.
                  FURTHER, LEMON.IO DOES NOT REPRESENT OR WARRANT THAT THE
                  PLATFORM IS FREE FROM VIRUSES, TROJAN HORSES, WORMS, TIME
                  BOMBS, SPIDERS, CANCEL BOTS, CORRUPTED FILES, OR ANY OTHER
                  SIMILAR SOFTWARE, MALWARE OR MATERIALS THAT MAY DAMAGE,
                  INTERFERE WITH, DISRUPT, IMPAIR, DISABLE OR OTHERWISE
                  OVERBURDEN THE OPERATION OF ANY DEVICE, COMPUTER SYSTEM OR
                  NETWORK. 
                </p>
              </li>
              <li>
                <p>
                  Release. TO THE EXTENT PERMITTED BY LAW, LEMON.IO HEREBY
                  EXPRESSLY DISCLAIMS, AND YOU HEREBY EXPRESSLY RELEASE LEMON.IO
                  FROM, ANY AND ALL DISPUTES FOR DAMAGES, INJURIES, LOSSES AND
                  LIABILITIES ASSOCIATED WITH THE FOLLOWING: (A) LEMON.IO’S OWN
                  NEGLIGENCE; (B) THAT USE OF THE PLATFORM WILL BE UNINTERRUPTED
                  OR ERROR-FREE; (C) THAT ANY SERVICES WILL BE RELIABLE,
                  ACCURATE, SAFE, TIMELY OR COMPLETE; (D) THE INACCURACY,
                  UNTIMELINESS OR INCOMPLETENESS OF ANY INFORMATION AND/OR
                  CONTENT INCLUDING, WITHOUT LIMITATION, ANY RELIANCE UPON SUCH
                  INFORMATION AND/OR CONTENT; (E) ANY MISSTATEMENTS OR
                  MISREPRESENTATIONS MADE BY ANY USER; (F) THIRD-PARTY WEBSITES
                  INCLUDING, WITHOUT LIMITATION, RELATED TO AVAILABILITY, TERMS
                  OF USE, PRIVACY PRACTICES, INFORMATION, CONTENT, MATERIALS,
                  ADVERTISING, CHARGES, PAYMENT, PRODUCTS AND/OR SERVICES; (G)
                  THE CONDUCT OF ANY USER ONLINE OR OFFLINE INCLUDING, WITHOUT
                  LIMITATION, HARASSMENT, ABUSE, DEFAMATION, INJURY, AND DAMAGE
                  TO OR DESTRUCTION OF PROPERTY; (G) THE CONDUCT OF THIRD
                  PARTIES INCLUDING, WITHOUT LIMITATION, HACKERS OR OTHERS WHO
                  ENGAGE IN THE UNAUTHORIZED ACCESS, USE OR MISAPPROPRIATION OF
                  ANY INFORMATION AND/OR CONTENT; AND (H) ANY INFORMATION AND/OR
                  CONTENT THAT MAY BE MISAPPROPRIATED, INTERCEPTED, DELETED,
                  DESTROYED OR USED BY OTHERS. 
                </p>
              </li>
              <li>
                <p>
                  Limitation of Liability. TO THE EXTENT PERMITTED BY LAW, UNDER
                  NO CIRCUMSTANCES WILL LEMON.IO BE LIABLE TO ANY USER OR ANY
                  THIRD PARTY FOR DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL,
                  SPECIAL, PUNITIVE OR EXEMPLARY DAMAGES ARISING FROM, IN
                  CONNECTION WITH OR IN ANY WAY RELATED TO THE SERVICES OR THE
                  PLATFORM, EVEN IF ADVISED OF THE POSSIBILITY OF THE SAME.
                  NOTWITHSTANDING ANYTHING IN THE TERMS OF USE TO THE CONTRARY,
                  IF IT IS DETERMINED THAT LEMON.IO IS LIABLE TO YOU, IN NO
                  EVENT WILL THE AGGREGATE LIABILITY, WHETHER ARISING IN
                  CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EXCEED
                  FIVE-HUNDRED DOLLARS ($500).
                </p>
              </li>
              <li>
                <p>
                  Indemnity. You agree to defend, indemnify and hold Lemon.io
                  harmless from and against any and all Disputes, including
                  without limitation for damages, injuries, losses, liabilities
                  and reasonable legal and accounting fees (collectively,
                  “Indemnified Claims”), resulting from, or alleged to result
                  from: (A) Your breach of the Terms of Use; (B) Any information
                  and/or content you submit to or transmit through the Platform,
                  (C) Your or misuse of the Platform including, without
                  limitation, your unauthorized or unlawful use of the Platform;
                  (D) Your violation of any applicable law, rule or regulation
                  pertaining to your use of the Platform; (E) The use of the
                  Platform by any other person using your account. We will use
                  reasonable efforts to provide you with prompt notice of any
                  such Indemnified Claims, and may assist you, at our expense
                  and option, in defending any such Indemnified Claims.
                </p>
              </li>
              <li>
                <p>
                  Waiver; Severability. Failure by Lemon.io to enforce any
                  provision(s) of the Terms of Use will not be construed as a
                  waiver of any provision or right. The Terms of Use constitute
                  the entire agreement between you and Lemon.io. If any
                  provision of the Terms of Use is found to be invalid or
                  unenforceable, the remaining provisions will be enforced to
                  the fullest extent possible, and the remaining provisions will
                  remain in full force and effect. The Terms of Use will inure
                  to the benefit of Lemon.io, its successors and assigns.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </section>
      <CantFindAnswer />
    </>
  );
}
